<div class="section">
  <div class="title"><span i18n="@@modifyDog">Modifica amico fedele:</span> {{amicoFedele.nome}} </div>

  <form #modifyAmicoFedele="ngForm" (ngSubmit)="modAmicoFedele()">
    <div class="card">
      <div class="card-content">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@chip" class="label" [ngClass]="{'has-text-danger' : !amicoFedele.chip}">Chip</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="amicoFedele.chip" name="chipFieldName"
                       required type="text" #chipField="ngModel" [ngClass]="{'is-danger' : !amicoFedele.chip}">
              </div>
              <p class="help is-danger" *ngIf="chipField.invalid && (chipField.touched || modifyAmicoFedele.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@breed" class="label" [ngClass]="{'has-text-danger' : !amicoFedele.razza}">Razza</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="amicoFedele.razza" name="razzaFieldName"
                       required type="text" #razzaField="ngModel" [ngClass]="{'is-danger' : !amicoFedele.razza}">
              </div>
              <p class="help is-danger" *ngIf="razzaField.invalid && (razzaField.touched || modifyAmicoFedele.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>

        <div class="field is-grouped field is-grouped-right">
          <div class="control">
            <a [routerLink]="['/area-utente', 'gruppo']" class="button is-danger" i18n="@@cancel">Annulla</a>
          </div>
          <div class="control">
            <button type="submit" class="button is-primary" i18n="@@save">Salva</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
